/**
 * エラーコードの定数定義
 */
export const ErrorCodeConstants = {
  // エラーコード一覧(4桁目'H'とする)
  ERROR_CODES: {
    EAPZ000001: 'EAPH000001',
    EAPZ000003: 'EAPH000003',
    EAPZ000004: 'EAPH000004',
    EAPZ000009: 'EAPH000009',
    EAPZ000010: 'EAPH000010',
    EAPZ000018: 'EAPH000018',
    EAPZ000019: 'EAPH000019',
    EAPZ000020: 'EAPH000020',
    EAPZ000050: 'EAPH000050',
    EAPZ000051: 'EAPH000051',
    EBAZ000015: 'EBAH000015',
    EBAA000002: 'EBAH100002',
    EBAA000003: 'EBAH100003',
    EIFA000001: 'EIFH100001',
    EIFA000002: 'EIFH100002',
    EIFA000003: 'EIFH100003',
    EIFA000004: 'EIFH100004',
    EIFA000005: 'EIFH100005',
    EIFA000006: 'EIFH100006',
    FDXZ000005: 'FDXH000005',
    FIFA000001: 'FIFH100001',
    EAGA000001: 'EAGH100001',
    EAGA000002: 'EAGH100002',
    EAGA000003: 'EAGH100003',
    EAGA000004: 'EAGH100004',
    EAGA000005: 'EAGH100005',
    EAGA000006: 'EAGH100006',
    EAGA000007: 'EAGH100007',
    EAPB000001: 'EAPH000001',
    EAPB000003: 'EAPH000003',
    EAPB000004: 'EAPH000004',
    EAPB000018: 'EAPH000018',
    EAPB000019: 'EAPH000019',
    EAPB000020: 'EAPH000020',
    EAPB000050: 'EAPH000050',
    EAPB000051: 'EAPH000051',
    EAPH000001: 'EAPH000001',
    EAPH000003: 'EAPH000003',
    EAPH000004: 'EAPH000004',
    EAPH000018: 'EAPH000018',
    EAPH000019: 'EAPH000019',
    EAPH000020: 'EAPH000020',
    EAPH000050: 'EAPH000050',
    EAPH000051: 'EAPH000051',
    EAPW000001: 'EAPH000001',
    EAPW000003: 'EAPH000003',
    EAPW000004: 'EAPH000004',
    EAPW000018: 'EAPH000018',
    EAPW000019: 'EAPH000019',
    EAPW000020: 'EAPH000020',
    EAPW000050: 'EAPH000050',
    EAPW000051: 'EAPH000051',
    EAPZ000011: 'EAPH000011',
    EAPZ000012: 'EAPH000012',
    EAPZ000013: 'EAPH000013',
    EAPZ000028: 'EAPH000028',
    EAPZ000029: 'EAPH000029',
    EAPZ000030: 'EAPH000030',
    EAPZ000034: 'EAPH000034',
    EAPZ000035: 'EAPH000035',
    EAPZ000036: 'EAPH000036',
    EAPZ000037: 'EAPH000037',
    EAPZ000038: 'EAPH000038',
    EAPZ000039: 'EAPH000039',
    EAPZ000040: 'EAPH000040',
    EAPZ000041: 'EAPH000041',
    EAPZ000042: 'EAPH000042',
    EAPZ000043: 'EAPH000043',
    EAPZ000044: 'EAPH000044',
    EAPZ000045: 'EAPH000045',
    EAPZ000046: 'EAPH000046',
    EAPZ000047: 'EAPH000047',
    EAPZ000049: 'EAPH000049',
    EAPZ000057: 'EAPH000057',
    EBAA000016: 'EBAH100016',
    EBAA000017: 'EBAH100017',
    EBAA000018: 'EBAH100018',
    EBAA000019: 'EBAH100019',
    EBAA000020: 'EBAH100020',
    EBAA000023: 'EBAH100023',
    EBAA000024: 'EBAH100024',
    EBAA000025: 'EBAH100025',
    EBAA000026: 'EBAH100026',
    EBAA000027: 'EBAH100027',
    EBAA000028: 'EBAH100028',
    EBAA000029: 'EBAH100029',
    EBAA000030: 'EBAH100030',
    EBAA000031: 'EBAH100031',
    EBAA000032: 'EBAH100032',
    EBAA000033: 'EBAH100033',
    EBAA000034: 'EBAH100034',
    EBAA100036: 'EBAH100036',
    EBAB000015: 'EBAH000015',
    EBAH000002: 'EBAH000002',
    EBAH000003: 'EBAH000003',
    EBAH000015: 'EBAH000015',
    EBAW000015: 'EBAH000015',
    EBAZ000023: 'EBAH000023',
    EBAZ000063: 'EBAH000063',
    EBAZ000101: 'EBAH000101',
    EBAZ000147: 'EBAH000147',
    EBAZ000157: 'EBAH000157',
    EBAZ000159: 'EBAH000159',
    EBAZ000163: 'EBAH000163',
    EBAZ000174: 'EBAH000174',
    EBAZ000186: 'EBAH000186',
    EBAZ000187: 'EBAH000187',
    EBAZ000195: 'EBAH000195',
    EBAZ000201: 'EBAH000201',
    EBAZ000202: 'EBAH000202',
    EBAZ000203: 'EBAH000203',
    EBAZ000205: 'EBAH000205',
    EBAZ000206: 'EBAH000206',
    EBAZ000207: 'EBAH000207',
    EBAZ000211: 'EBAH000211',
    EBAZ000212: 'EBAH000212',
    EBAZ000213: 'EBAH000213',
    EBAZ000215: 'EBAH000215',
    EBAZ000218: 'EBAH000218',
    EBAZ000219: 'EBAH000219',
    EBAZ000221: 'EBAH000221',
    EBAZ000252: 'EBAH000252',
    EBAZ000265: 'EBAH000265',
    EBAZ000277: 'EBAH000277',
    EBAZ000278: 'EBAH000278',
    EBAZ000285: 'EBAH000285',
    EBAZ000286: 'EBAH000286',
    EBAZ000287: 'EBAH000287',
    EBAZ000288: 'EBAH000288',
    EBAZ000289: 'EBAH000289',
    EBAZ000290: 'EBAH000290',
    EBAZ000297: 'EBAH000297',
    EBAZ000299: 'EBAH000299',
    EBAZ000300: 'EBAH000300',
    EBAZ000301: 'EBAH000301',
    EBAZ000302: 'EBAH000302',
    EBAZ000307: 'EBAH000307',
    EBAZ000308: 'EBAH000308',
    EBAZ000309: 'EBAH000309',
    EBAZ000314: 'EBAH000314',
    EBAZ000315: 'EBAH000315',
    EBAZ000371: 'EBAH000371',
    EBAZ000372: 'EBAH000372',
    EBAZ000378: 'EBAH000378',
    EBAZ000400: 'EBAH000400',
    EBAZ000412: 'EBAH000412',
    EBAZ000422: 'EBAH000422',
    EBAZ000423: 'EBAH000423',
    EBAZ000427: 'EBAH000427',
    EBAZ000428: 'EBAH000428',
    EBAZ000429: 'EBAH000429',
    EBAZ000430: 'EBAH000430',
    EBAZ000431: 'EBAH000431',
    EBAZ000432: 'EBAH000432',
    EBAZ000437: 'EBAH000437',
    EBAZ000479: 'EBAH000479',
    EBAZ000493: 'EBAH000493',
    EBAZ000502: 'EBAH000502',
    EBAZ000503: 'EBAH000503',
    EBAZ000504: 'EBAH000504',
    EBAZ000508: 'EBAH000508',
    EBAZ000509: 'EBAH000509',
    EBAZ000516: 'EBAH000516',
    EBAZ000520: 'EBAH000520',
    EBAZ000528: 'EBAH000528',
    EBAZ000529: 'EBAH000529',
    EBAZ000530: 'EBAH000530',
    EBAZ000531: 'EBAH000531',
    EBAZ000533: 'EBAH000533',
    EBAZ000534: 'EBAH000534',
    EBAZ000535: 'EBAH000535',
    EBAZ000536: 'EBAH000536',
    EBAZ000537: 'EBAH000537',
    EBAZ000543: 'EBAH000543',
    EBAZ000545: 'EBAH000545',
    EBAZ000546: 'EBAH000546',
    EBAZ000547: 'EBAH000547',
    EBAZ000548: 'EBAH000548',
    EBAZ000549: 'EBAH000549',
    EBAZ000551: 'EBAH000551',
    EBAZ000552: 'EBAH000552',
    EBAZ000559: 'EBAH000559',
    EBAZ000574: 'EBAH000574',
    EBAZ000627: 'EBAH000627',
    EBAZ000628: 'EBAH000628',
    EBAZ000629: 'EBAH000629',
    EBAZ000674: 'EBAH000674',
    EBAZ000675: 'EBAH000675',
    EBAZ000676: 'EBAH000676',
    EBAZ000695: 'EBAH000695',
    EBAZ000824: 'EBAH000824',
    EBAZ000841: 'EBAH000841',
    EBAZ000842: 'EBAH000842',
    EBAZ000844: 'EBAH000844',
    EBAZ000845: 'EBAH000845',
    ECLZ000001: 'ECLH000001',
    ECLZ000002: 'ECLH000002',
    ECLZ000003: 'ECLH000003',
    EDGA000001: 'EDGH100001',
    EDGA000002: 'EDGH100002',
    EDGA000003: 'EDGH100003',
    EDGA000004: 'EDGH100004',
    EDGA000005: 'EDGH100005',
    EDGA000006: 'EDGH100006',
    EDGA000007: 'EDGH100007',
    EDGA000008: 'EDGH100008',
    EDGA000009: 'EDGH100009',
    EDGA000010: 'EDGH100010',
    EDGA000011: 'EDGH100011',
    EDGA000012: 'EDGH100012',
    EDGA000013: 'EDGH100013',
    EDGA000014: 'EDGH100014',
    EDGA000015: 'EDGH100015',
    EDGA000016: 'EDGH100016',
    EDGA000017: 'EDGH100017',
    EIFA000007: 'EIFH100007',
    EIFA000008: 'EIFH100008',
    EIFA000009: 'EIFH100009',
    EIFA000010: 'EIFH100010',
    EIFA000011: 'EIFH100011',
    EIFH000001: 'EIFH000001',
    EIFH000002: 'EIFH000002',
    EIFH000003: 'EIFH000003',
    EIFH000004: 'EIFH000004',
    EIFH000005: 'EIFH000005',
    EIFH000006: 'EIFH000006',
    FAGA000001: 'FAGH100001',
    FDGA000001: 'FDGH100001',
    FDXB000005: 'FDXH000005',
    FDXH000005: 'FDXH000005',
    FDXW000005: 'FDXH000005',
    FIFH000001: 'FIFH000001',
    FITA000001: 'FITH100001',
    WBAZ000048: 'WBAH000048',
    WBAZ000198: 'WBAH000198',
    WBAZ000199: 'WBAH000199',
    WBAZ000200: 'WBAH000200',
    WBAZ000201: 'WBAH000201',
    WBAZ000203: 'WBAH000203',
    WBAZ000206: 'WBAH000206',
    WBAZ000207: 'WBAH000207',
    WBAZ000210: 'WBAH000210',
    WBAZ000211: 'WBAH000211',
    WBAZ000212: 'WBAH000212',
    WBAZ000213: 'WBAH000213',
    WBAZ000214: 'WBAH000214',
    WBAZ000253: 'WBAH000253',
    WBAZ000254: 'WBAH000254',
    WBAZ000257: 'WBAH000257',
    WBAZ000355: 'WBAH000355',
    WBAZ000426: 'WBAH000426',
    WBAZ000428: 'WBAH000428',
    WBAZ000430: 'WBAH000430',
    WBAZ000505: 'WBAH000505',
    WBAZ000511: 'WBAH000511',
    WBAZ000512: 'WBAH000512',
    WBAZ000513: 'WBAH000513',
    WBAZ000520: 'WBAH000520',
    WBAZ000522: 'WBAH000522',
    WBAZ000523: 'WBAH000523',
    WBAZ000524: 'WBAH000524',
    WBAZ000558: 'WBAH000558',
    WBAZ000601: 'WBAH000601',
    WBAZ100014: 'WBAH100014',
    WBAA100010: 'WBAH100010',
    WBAA100011: 'WBAH100011',
    EBAA100035: 'EBAH100035',
    FIFA000002: 'FIFH100002',
  },
};

/**
 * 共通処理で利用する定数の定義
 */
export const CommonConstants = {
  THREE_LETTER: 'ADO',
  // オフィスコードチェック用定数
  OFFICE_CODE_JP: 'SPKHD08', // 日本統合オフィスコード
  OFFICE_CODE_JP_R: 'SPKHD08AA', // 有償日本オフィス
  OFFICE_CODE_JP_R_APF: '', // 有償日本オフィスAPF
  OFFICE_CODE_JP_A: 'SPKHD08ZZ', // 特典日本オフィス
  // 提携3社ログインモーダルで(ADO,SFJ,SNJ)会員番号チェック用定数
  MEMBER_NUMBER_RULES: {
    type: 'alphaNumberic' as 'alphaNumberic' | 'numberic',
    length: 10,
  },
  // ログインモーダルのパスワードチェック用定数
  PASSWORD_RULES: {
    minPwLength: 8,
    maxPwLength: 20,
    pwRegex: '^[a-zA-Z0-9-_.+$#!/@(%&*?)]*$',
  },
  // ログイン情報連携機能が有効か
  LOGIN_INFO_INTEGRATION_ENABLED: true,
  // 提携社サイトに戻る際のURL切り替え機能が有効か
  RETURN_URL_SWITCH_ENABLED: true,
  LOGO_FILE_PATH: 'assets/images/logo_ado.svg',
  // 法人ヘッダー用ロゴファイルパス
  LOGO_BIZ_FILE_PATH: 'assets/images/logo_ado_biz.png',
  // ログインAPIエラーコードMAP
  LOGIN_API_ERROR_MAP: {
    [ErrorCodeConstants.ERROR_CODES.EIFA000001]: 'EA021', // ログイン情報なし
    [ErrorCodeConstants.ERROR_CODES.EIFA000002]: 'EA022', // ログイン情報が無効
    [ErrorCodeConstants.ERROR_CODES.EIFA000003]: 'EA014', // 一定時間内のログイン試行回数超過によりブロックされた会員
    [ErrorCodeConstants.ERROR_CODES.EIFA000004]: 'EA020', // パスワード不一致
    [ErrorCodeConstants.ERROR_CODES.EIFA000005]: 'EA013', // パスワード有効期限切れ
    [ErrorCodeConstants.ERROR_CODES.EIFA000006]: 'EA016',
    [ErrorCodeConstants.ERROR_CODES.EIFA000007]: 'EA023',
    [ErrorCodeConstants.ERROR_CODES.EIFA000009]: 'EA017',
    [ErrorCodeConstants.ERROR_CODES.EIFA000010]: 'EA026',
    [ErrorCodeConstants.ERROR_CODES.EIFA000011]: 'EA015',
    [ErrorCodeConstants.ERROR_CODES.EBAA000002]: 'EA050', // 会員区分が無効会員の場合
    [ErrorCodeConstants.ERROR_CODES.EBAA000003]: 'EA051', // 認証結果がfalse
    [ErrorCodeConstants.ERROR_CODES.EAPZ000009]: 'E0361', // 搭乗者に含まれているかチェック
    [ErrorCodeConstants.ERROR_CODES.EAPZ000010]: 'E0361', // マイル減算者の会員かチェックエラー
    [ErrorCodeConstants.ERROR_CODES.FIFA000001]: 'EA015', // ifly接続エラー(想定外エラー)
    [ErrorCodeConstants.ERROR_CODES.FIFA000002]: 'EA019', // iflyエラー
  } as { [key: string]: string },
  // InlineTelemetry付与対象URL
  INLINETELEMETRY_URL: {
    AUTH_LOGIN: {
      ENDPOINT: /\/all-.*-member\/api\/.*\/auth-login/,
      METHOD: 'POST',
    },
    PAYMENT_RECORD: {
      ENDPOINT: /\/all-.*-reservation\/api\/.*\/orders\/payment-records/,
      METHOD: 'POST',
    },
    CREATE_ORDER: {
      ENDPOINT: /\/all-.*-reservation\/api\/.*\/orders\/create-order/,
      METHOD: 'POST',
    },
    CAPTCHA_AUTHENTICATION: {
      ENDPOINT: /\/all-.*-search\/api\/.*\/captcha-authentication$/,
      METHOD: 'POST',
    },
    CREATE_CART: {
      ENDPOINT: /\/all-.*-reservation\/api\/.*\/carts\/create-cart/,
      METHOD: 'POST',
    },
    ROUNDTRIP_FPP: {
      ENDPOINT: /\/all-.*-search\/api\/.*\/roundtrip-fpp/,
      METHOD: 'POST',
    },
  } as { [key: string]: { ENDPOINT: RegExp; METHOD: string } },
} as const;

/**
 * APP内で利用する定数の定義
 */
export const AppConstants = {
  // 全個社で利用する定数は、baseプロジェクトでは空文字などで定義する。
  // FIXME: 各APPごとに指定する
  //画像の定数一覧
  IMG: {
    PARTNER_COMPANY_ICON: './assets/images/logo_ado_s.svg',
    LOGO_S_WIDTH: '56',
    LOGO_S_HEIGHT: '22',
    // R01_P070_S01_U: シートマップ画面
    R01_P070_S01_U__SEATMAP__SEATMAP_AISLE_SHORT: './assets/images/seatmap_aisle_short.svg',
    R01_P070_S01_U__SEGMENTS__ICON_CHECK_PRIMARY_20: './assets/images/icon_check_ado_blue_20.svg',
    R01_P070_S01_U__SEAT_PRODUCTS_MODAL__ICON_EXTERNAL_PRIMARY_16: './assets/images/icon_external_ado_blue_16.svg',
    R01_P070_S01_U__LEGENDS_MODAL__BTN_ARROW_CIRCLE_LEFT_40: './assets/images/btn_arrow_circle_left_40.svg',
    R01_P070_S01_U__LEGENDS_MODAL__BTN_ARROW_CIRCLE_RIGHT_40: './assets/images/btn_arrow_circle_right_40.svg',
    R01_P070_S01_U__FLOADING_NAVI__SEATMAP_FLOAT_SEATTYPE: './assets/images/seatmap_float_seattype_ado.svg',
    R01_P070_S01_U__FLOADING_NAVI__SEATMAP_FLOAT_LEGEND: './assets/images/seatmap_float_legend_ado.svg',
    R01_P070_S01_U__SEAT_EXITDOOR: './assets/images/seat_exitdoor.svg',
    R01_P070_S01_U__SEAT_FREE_SEAT_24: './assets/images/seat_ado_seat_24.svg',
    R01_P070_S01_U__SEAT_BACK_SEAT_24: './assets/images/seat_back_seat_24.svg',
    R01_P070_S01_U__SEAT_EMERGENCY_EXIT_SEAT_24: './assets/images/seat_emergency_exit_seat_ado_24.svg',
    R01_P070_S01_U__SEAT_UNAVAILABLE_24: './assets/images/seat_unavailable_24.svg',
    R01_P070_S01_U__SEAT_INFANT_24: './assets/images/seat_infant_24.svg',
    R01_P070_S01_U__SEAT_SELECTED_24: './assets/images/seat_selected_ado_24.svg',
    R01_P070_S01_U__SEAT_BEFORE_CHANGE_FREE_SEAT_24: './assets/images/seat_before_change_free_seat_ado_24.svg',
    R01_P070_S01_U__SEAT_UNCHANGEABLE_24: './assets/images/seat_unchangeable_ado_24.svg',
    R01_P070_S01_U__SEAT_NO_WINDOW_24: './assets/images/seat_no_window_ado_24.svg',
    R01_P070_S01_U__SEAT_NO_WINDOW: './assets/images/seat_no_window_ado.svg',
    R01_P070_S01_U__SEAT_NO_RECLINING_24: './assets/images/seat_no_reclining_ado_24.svg',
    R01_P070_S01_U__SEAT_NO_RECLINE: './assets/images/seat_no_recline_ado.svg',
    R01_P070_S01_U__SEAT_TABLE_24: './assets/images/seat_table_24.svg',
    R01_P070_S01_U__SEAT_LAVATORY_24: './assets/images/seat_lavatory_ado_24.svg',
    R01_P070_S01_U__SEAT_MULTI_PURPOSE_ROOM_24: './assets/images/seat_multi_purpose_room_24.svg',
    R01_P070_S01_U__SEAT_AISLE_24: './assets/images/seat_aisle_24.svg',
    R01_P070_S01_U__SEAT_EMERGENCY_EXIT_24: './assets/images/seat_emergency_exit_24.svg',
    R01_P070_S01_U__SEAT_WING_24: './assets/images/seat_wing_ado_24.svg',
    R01_P070_S01_U__SEAT_GALLEY_24: './assets/images/seat_galley_ado_24.svg',
    R01_P070_S01_U__SEAT_PARTITION_24: './assets/images/seat_partition_24.svg',
    R01_P070_S01_U__SEAT_BAR_24: './assets/images/seat_bar_24.svg',
    R01_P070_S01_U__SEAT_STAIR_24: './assets/images/seat_stair_24.svg',
    R01_P070_S01_U__SEAT_BASSINET_24: `assets/images/seat_bassinet_24.svg`,
    // R01_P040_S01_U: プラン確認画面
    R01_P040_S01_U__ICON_CHANGED_18: './assets/images/icon_changed_18.svg',
    R01_P040_S01_U__ICON_CHANGE_10: './assets/images/icon_change_ado_blue_10.svg',
    // R01_P031_S01_U: 往復空席照会結果(国内)画面
    R01_P031_S01_U__ICON_FILTER_20: 'assets/images/icon_filter_ado_blue_20.svg',
    R01_P031_S01_U__ICON_SORT_20: 'assets/images/icon_sort_ado_blue_20.svg',
  },
  //実装で使う定数一覧
  CARRIER: {
    TWO_LETTER: 'HD',
    THREE_LETTER: 'ADO',
  },
  FARE_OPTION_DISABILITY_DISCOUNT: [10, 67, 68, 69, 70, 71, 72, 73],
} as const;
